function getPrice(prices) {
    if (!Array.isArray(prices) || !prices.length || !prices[0]) {
        return undefined;
    }
    const price = prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode
        };
    }
    const discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount
    };
}

export { getPrice };
//# sourceMappingURL=get-price.js.map
